module.exports = __webpack_public_path__ + "static/media/Bitstamp.ccc96534.svg";